import { compact } from 'lodash-es';
import { RouteTitleMap } from '@/routing/document-title';

const APP_SUFFIX = 'NOP Connect';

export const DEFAULT_TITLE = APP_SUFFIX;

const withAppSuffix = (...segments: (string | undefined)[]) => {
  return compact([...segments, APP_SUFFIX]).join(' • ');
};

export const routeTitleConfig: RouteTitleMap = {
  '/': withAppSuffix('Cases Board'),
  '/case/:caseId/details': ({ unosId }) => withAppSuffix(unosId, 'Details'),
  '/case/:caseId/resources': ({ unosId }) => withAppSuffix(unosId, 'Resources'),
  '/case/:caseId/clinical': ({ unosId }) => withAppSuffix(unosId, 'Clinical'),
  '/case/:caseId/log': ({ unosId }) => withAppSuffix(unosId, 'Log'),
  '/case/:caseId/access': ({ unosId }) => withAppSuffix(unosId, 'Access'),
  '/case/:caseId/location-tracking': ({ unosId }) => withAppSuffix(unosId, 'Location Tracking'),
  '/case/:caseId/planner/*': ({ unosId }) => withAppSuffix(unosId, 'Planner'),
  '/case/:caseId/*': ({ unosId }) => withAppSuffix(unosId),
  '/schedule/cs/*': withAppSuffix('Schedule', 'Specialists'),
  '/schedule/s-li/*': withAppSuffix('Schedule', 'Surgeons Liver'),
  '/schedule/s-htlu/*': withAppSuffix('Schedule', 'Surgeons Lungs & Heart'),
  '/schedule/cc/*': withAppSuffix('Schedule', 'Coordinators'),
  '/schedule/oms/*': withAppSuffix('Schedule', 'OMS'),
  '/schedule/*': withAppSuffix('Schedule'),
  '/notifications': withAppSuffix('Notifications'),
  '/archive': withAppSuffix('Archive'),
  '/bulk-assignment': withAppSuffix('Bulk Assignment'),
  '/multi-case-suggest/*': withAppSuffix('Multi Case Suggest'),
  '/chats': withAppSuffix('Chats'),
  '/profile': withAppSuffix('Profile'),
  '/profile/settings/*': withAppSuffix('Profile Settings'),
  '/admin/*': withAppSuffix('Admin Panel'),
  '/sign-in': withAppSuffix('Sign In'),
  '/no-access': withAppSuffix('No Access'),
};
